import { useRef, useState } from "react";
import { AddCommitteeApprovalFormData } from "../data/AddCommitteeApprovalForm.Data";
import Buttons from "../../../components/ui/button/Buttons";
import FormCreator from "../../../components/Forms/FormCreator";
import { forwardRef } from "react";
import { useImperativeHandle } from "react";

const AddCommitteeApprovalForm  = forwardRef((props, ref) =>{
    const addMemberFormRef = useRef();
    const [formData, setFormData] = useState(AddCommitteeApprovalFormData);
    useImperativeHandle(ref, () => ({
        getFormData: () => {
            if (ref?.current) {
                const addMemberFormData = addMemberFormRef.current.getFormData();
                return addMemberFormData;
            }
            return null;
        }
    }))
    const handleAddMember = () => {
        if (props?.handleSaveMember) {
            props?.handleSaveMember();
        }
    }
    return (<>
        <div className='container'>
            <div className='row'>
                <FormCreator ref={addMemberFormRef} {...formData} />
            </div>
            <div className='row'>
                <div className='col-lg-12'>
                    <Buttons
                        buttonText="Submit"
                        buttonTypeClassName="btn success-btn mr-auto ml-0 mt-2"
                        isLoading={props?.isLoadingAddMember}
                        isDisable={props?.isLoadingAddMember}
                        onClick={handleAddMember}
                    />
                </div>
            </div>
        </div>
    </>)
})
export default AddCommitteeApprovalForm;